import React from 'react';
import LaboratoryDashboard from './LaboratoryDashboard';
import AUAnalystDashboard from '../dashboards/AUAnalystDashboard';
import AUSupervisorDashboard from '../dashboards/AUSupervisorDashboard';

interface AULaboratoryDashboardProps {
  userRole: 'ANALYSTE' | 'TECHNICIEN' | 'SUPERVISEUR';
  userId: string;
}

const AULaboratoryDashboard: React.FC<AULaboratoryDashboardProps> = ({
  userRole,
  userId,
}) => {
  // Use comprehensive AU analyst dashboard for analysts
  if (userRole === 'ANALYSTE') {
    return <AUAnalystDashboard />;
  }

  // Use comprehensive AU supervisor dashboard for supervisors
  if (userRole === 'SUPERVISEUR') {
    return <AUSupervisorDashboard />;
  }

  // Use generic laboratory dashboard for technicians
  return (
    <LaboratoryDashboard
      laboratoryType="AU"
      laboratoryName="Laboratoire AU (Analyse de l'Or)"
      userRole={userRole}
      userId={userId}
    />
  );
};

export default AULaboratoryDashboard; 